<template>
  <b-overlay :show="estoreIsLoadingOverlay" rounded="sm" style="top: -11px;">
    <div
      :class="[
        'order-details',
        { 'pb-10': !isMobile, 'shadow-none pb-4': isMobile }
      ]"
    >
      <div
        id="medpadala-credits"
        class="px-4 py-3 border-bottom"
        v-if="medPadalaCustomization"
      >
        <img
          :src="medPadalaCustomization.logo"
          alt="MEDPadala"
          class="medpadala-logo mb-3"
        />
        <b-row no-gutters v-if="isAppliedMedPadalaCredits">
          <b-col>
            <p class="text-muted">{{ medPadalaCustomization.cart_hint }}</p>
          </b-col>
          <b-col class="text-right">
            <i
              class="text-normal right-caret d-inline-block"
              @click="$root.$emit('bv::show::modal', 'medpadala-modal')"
            >
            </i>
          </b-col>
        </b-row>
        <template v-else>
          <div
            class="
              bg-light
              rounded
              p-2
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <span>
              {{
                hasMEDPadalaCredits
                  ? medPadalaWallet.wallet_code
                  : medPadalaData.code
              }}
            </span>
            <span>
              <img
                src="@/assets/images/checkmark.png"
                alt="MEDPadala Credits Applied"
                class="mr-2"
              />
              <b-button
                class="
                  medpadala-credits-action
                  p-0
                  bg-transparent
                  shadow-none
                  border-0
                "
                @click="removeMedPadalaCredits"
                :disabled="medPadalaLoading"
              >
                <img
                  src="@/assets/images/clear-icon.png"
                  alt="Remove MEDPadala Code"
                />
              </b-button>
            </span>
          </div>
        </template>
      </div>
      <div
        :class="['order-details-body', { 'border-top': isMobile }]"
        v-if="cart"
      >
        <!-- Start Promo Code: for Cart Linking Drop 2
        <div class="font-weight-normal mb-2">Promo Code</div>
        <div v-if="cart.voucher_info">
          <b-container class="border rounded py-2 px-3">
            <b-row v-if="voucherIsLoading">
              <b-col class="text-center">
                REMOVING...
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                {{ cart.voucher_info.code }}
              </b-col>
              <b-col class="text-right">
                <img
                  src="@/assets/images/ic-close.svg"
                  alt="Close"
                  class="close-icon"
                  @click="removeVoucher"
                />
              </b-col>
            </b-row>
          </b-container>
          <small
            v-if="cart.voucher_info.error"
            class="d-block mt-2 text-danger"
          >
            {{ cart.voucher_info.error }}
          </small>
        </div>
        <div class="pc-input" v-else>
          <input
            type="text"
            v-model="voucherCode"
            placeholder="Enter Promo Code"
            :class="{ 'w-100 mb-3': isMobile }"
          />
          <input
            v-if="webDesign !== null && webDesign.design !== null"
            :style="{
              backgroundColor: webDesign.design.main_color + '!important',
              border: 'none !important',
              color: webDesign.design.button_text_color + '!important'
            }"
            type="button"
            @click="verifyVoucher"
            :class="['btn btn-core', { 'mb-3': isMobile }]"
            :value="voucherIsLoading ? 'VERIFYING...' : 'APPLY'"
            :disabled="estoreIsLoading || !voucherCode"
          />
          <input
            v-else
            type="button"
            @click="verifyVoucher"
            :class="['btn btn-core', { 'mb-3': isMobile }]"
            :value="voucherIsLoading ? 'VERIFYING...' : 'APPLY'"
            :disabled="estoreIsLoading || !voucherCode"
          />
        </div>
        End Promo Code: for Cart Linking Drop 2 -->
        <div class="order-details-body-bd">
          <label class="h6">Subtotal</label>
          <span class="font-weight-bold" v-if="cart && cart.data.cart_total_amount"
            >&#8369; {{ putComma(Number(cart.data.cart_total_amount).toFixed(2)) }}</span
          >
        </div>
        <div
          class="order-details-body-bd"
          v-for="(fee, index) in cart.data.fees"
          v-bind:key="index"
        >
          <template
            v-if="fee.name === 'Delivery_fee' && hideDeliveryFee"
          ></template>
          <template
            v-else-if="fee.name === 'Delivery Fee' && fee.calculated_amount === 0"
          >
            <label class="text-capitalize h6">Delivery Fee</label>
            <span class="font-weight-bold">FREE</span>
          </template>
          <template v-else>
            <label class="text-capitalize h6">{{ fee.name.replace(/_/g, " ") }}</label>
            <span v-if="cart.data.cart_count != 0" class="font-weight-bold"
              >&#8369;
              {{ putComma(parseFloat(fee.calculated_amount).toFixed(2)) }}</span
            >
            <span v-else>&#8369; 0.00</span>
          </template>
        </div>
        <div
          class="
            order-details-body-bd
            d-flex
            justify-content-between
            align-items-center
            mb-2
          "
          v-if="!isAppliedMedPadalaCredits && medPadalaCustomization"
        >
          <img
            :src="medPadalaCustomization.logo"
            alt="MEDPadala Credits"
            class="medpadala-logo"
          />
          <span
            class="text-uppercase text-primary"
            :style="{
              color:
                webDesign && webDesign.design
                  ? `${webDesign.design.main_color} !important`
                  : null
            }"
          >
            <span class="font-weight-bold"
              >- &#8369;
              {{
                medPadalaData.amount === null
                  ? medPadalaWallet.amount
                  : medPadalaData.amount | twoDecimalPlaces
              }}</span
            >
          </span>
        </div>
        <!-- Start Promo Code: for Cart Linking Drop 2
        <div class="order-details-body-bd" v-if="cart.data.voucher_info">
          <label class="h6">Promo ({{ cart.data.voucher_info.code }})</label>
          <span class="text-primary font-weight-bold"
            >- &#8369;{{ cart.data.voucher_amount.toFixed(2) }}</span
          >
        </div>
        <hr />
        End Promo Code: for Cart Linking Drop 2 -->
        <div class="order-details-body-bd strong">
          <label class="h5 font-weight-bold">Total</label>
          <!-- Start Promo Code: for Cart Linking Drop 2
          <span
            v-if="cart.data.voucher_info"
            class="text-primary h5 font-weight-bold"
            >&#8369;
            {{
              cart && cart.data.computed_total ? cart.data.computed_total.toFixed(2) : 0
            }}</span
          >
          End Promo Code: for Cart Linking Drop 2 -->
          <span
            v-if="cart.data.cart_count != 0"
            class="text-primary h5 font-weight-bold"
          >
            &#8369;
            {{
              cart && cart.data.computed_total ? cart.data.computed_total.toFixed(2) : 0
            }}
          </span>
          <span v-else class="text-primary h5 font-weight-bold"
            >&#8369; 0.00</span
          >
        </div>
      </div>
      <div
        :class="['order-details-actions', { 'mb-3': isMobile }]"
        v-if="!checkoutButton"
      >
        <button
          :disabled="cart.data.cart_count == 0 || disabledButton == true"
          type="submit"
          class="btn btn-core"
          v-if="webDesign !== null && webDesign.design !== null"
          :style="{
            backgroundColor: webDesign.design.main_color + '!important',
            border: 'none !important',
            color: webDesign.design.button_text_color + '!important'
          }"
        >
          CHECKOUT
        </button>
        <button
          :disabled="cart.data.cart_count == 0 || disabledButton == true"
          type="submit"
          class="btn btn-core"
          v-else
        >
          CHECKOUT
        </button>
      </div>
    </div>
    <!-- Start Promo Code: for Cart Linking Drop 2
    <b-modal ref="invalidPromo" hide-footer>
      <div class="modal-body aCenter">
        <img src="@/assets/images/info.svg" class="mt-10" />
        <p v-if="voucher">{{ voucher.message }}</p>
      </div>
    </b-modal>
    End Promo Code: for Cart Linking Drop 2 -->
    <MedPadalaModal />
  </b-overlay>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { Decimal } from "decimal.js";
import MedPadalaModal from "./MEDPadala/MedPadalaModal";
import { ls } from "@/utilities";

export default {
  name: "Computation",
  props: ["checkoutButton"],
  components: {
    MedPadalaModal
  },
  computed: {
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    ...mapState("estore", {
      cart: state => state.cart,
      products: state => state.products,
      estoreIsLoadingOverlay: state => state.loadingOverlay,
      estoreIsLoading: state => state.loading,
      voucherIsLoading: state => state.loading_voucher,
      estoreErrors: state => state.errors,
      voucher: state => state.voucher,
      webDesign: state => state.webDesign
    }),
    ...mapGetters({
      medPadalaData: "medpadala/medPadalaData",
      medPadalaCustomization: "medpadala/medPadalaCustomization",
      medPadalaErrors: "medpadala/medPadalaErrors",
      medPadalaLoading: "medpadala/medPadalaLoading"
    }),
    ...mapFields("medpadala", ["code", "pin", "amount", "appliedCredits"]),
    ...mapFields("estore", ["cart.estore_wallets", "cart.computed_total"]),
    isAppliedMedPadalaCredits() {
      const hasWallets = this.cart?.data?.estore_wallets;
      const hasMedPadala = hasWallets?.some(wallet => wallet.type === "med-padala");
      return !this.medPadalaData.appliedCredits && hasWallets && !hasMedPadala;
    },
    hasMEDPadalaCredits() {
      const hasWallets = this.cart?.data?.estore_wallets;
      const hasMedPadala = hasWallets?.some(wallet => wallet.type === "med-padala");
      return !this.medPadalaData.code && hasMedPadala;
    },
    medPadalaWallet() {
      return this.cart.estore_wallets
        ? this.cart.estore_wallets.find(wallet => wallet.type === "med-padala")
        : false;
    }
  },
  created: function() {
    this.isMobile = window.innerWidth < 845;
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth < 845;
    });
    this.$root.$on("updateHideDeliveryFee", el => {
      this.hideDeliveryFee = el;
    });
  },
  data() {
    return {
      voucherCode: null,
      isMobile: false,
      disabledButton: false,
      inputPoints: null,
      hideDeliveryFee: true
    };
  },
  methods: {
    ...mapActions({
      medPadalaRemove: "estore/medPadalaRemove"
    }),
    // Start Promo Code: for Cart Linking Drop 2
    // async verifyVoucher() {
    //   if (this.customerPortalToken != null) {
    //     let request = {
    //       header: {
    //         Authorization: this.token,
    //         "X-Merchant-Token": this.customerPortalToken
    //       },
    //       payload: {
    //         voucher_code: this.voucherCode
    //       }
    //     };

    //     await this.$store.dispatch("estore/verifyVoucher", request).then(() => {
    //       if (this.voucher && this.voucher.valid) {
    //         this.applyVoucher();
    //       } else {
    //         this.$refs["invalidPromo"].show();
    //         this.voucherCode = null;
    //       }
    //     });
    //   }
    // },
    // async applyVoucher() {
    //   if (this.customerPortalToken != null) {
    //     let request = {
    //       header: {
    //         Authorization: this.token,
    //         "X-Merchant-Token": this.customerPortalToken
    //       },
    //       payload: {
    //         voucher_code: this.voucher.voucher_code.code
    //       }
    //     };

    //     await this.$store.dispatch("estore/applyVoucher", request).then(() => {
    //       this.$store.commit("estore/SET_LOADING_OVERLAY", false);
    //       this.voucherCode = null;
    //     });
    //   }
    // },
    // async removeVoucher() {
    //   if (this.customerPortalToken) {
    //     const request = {
    //       header: {
    //         Authorization: this.token,
    //         "X-Merchant-Token": this.customerPortalToken
    //       }
    //     };

    //     await this.$store.dispatch("estore/removeVoucher", request).then(() => {
    //       this.$store.commit("estore/SET_LOADING_OVERLAY", false);
    //     });
    //   }
    // },
    // End Promo Code: for Cart Linking Drop 2
    computeFee(fee) {
      if (fee != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        let totalOrders = this.cart.data.cart_amount;

        totalOrders = new Decimal(Number(totalOrders.toString().match(re)[0]));

        if (fee.value_type == "%") {
          let feePercent = this.putComma(
            totalOrders
              .dividedBy(100)
              .times(fee.value)
              .toFixed(2)
          );

          return feePercent;
        } else {
          if (this.cart.cart_count != 0) {
            return this.putComma(fee.value);
          } else {
            return (fee.value = 0);
          }
        }
      }
    },
    computeTotal(fees) {
      var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
      let totalTransactionOrders = this.cart.data.cart_amount;

      totalTransactionOrders = new Decimal(
        Number(totalTransactionOrders.toString().match(re)[0])
      );
      let feesTotal = 0;

      for (let index = 0; index < fees.length; index++) {
        feesTotal += parseFloat(fees[index].calculated_amount);
      }
      feesTotal = Number(feesTotal.toString().match(re)[0]);
      if (this.cart.cart_count != 0) {
        return this.putComma(totalTransactionOrders.plus(feesTotal).toFixed(2));
      } else {
        return (feesTotal = 0);
      }
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    showModal(uuid, index) {
      this.$refs.modal.showModal(uuid, index);
    },
    async removeMedPadalaCredits() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      await this.medPadalaRemove(request).then(response => {
        if (this.medPadalaErrors === null) {
          this.code = null;
          this.pin = null;
          this.amount = null;
          this.appliedCredits = false;
          this.$nextTick(() => {
            this.cart.estore_wallets = response.estore_wallets;
            this.cart.computed_total = response.computed_total;
            ls.remove("MEDPadalaPin");
          });
        }
      });
    }
  },
  filters: {
    twoDecimalPlaces: function(value = null) {
      if (value != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        var sNumber = Number(value.toString().match(re)[0]);
        let twoDecimalPlaces = new Decimal(sNumber);
        return Number(twoDecimalPlaces).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../../assets/styles/views/cart/_base.scss";
#medpadala-credits {
  .right-caret {
    width: 14px;
    height: 8px;
    background: url("./../../assets/images/arrow-down.svg") no-repeat center;
    transform: rotate(-90deg);
    cursor: pointer;
  }
}
.medpadala-logo {
  width: 120px;
  height: auto;
}

#use-points-container {
  input[type="number"] {
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      -moz-appearance: textfield;
      appearance: none;
      margin: 0;
    }
  }
  input:focus {
    outline: 0px !important;
    box-shadow: none !important;
    border-color: #d8dcde;
  }
}
.close-icon {
  width: 25px;
  background: #dee2e6;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
}
</style>
